import { inject } from '@angular/core';
import { BranchesApi, BranchLocationBase } from '@idealsupply/ngclient-webservice-branches';
import { signalStore } from '@ngrx/signals';
import { map } from 'rxjs';
import { withCachedEntityCollectionStore } from 'state-data';

export const BranchStore = signalStore(
  { providedIn: 'root' },
  withCachedEntityCollectionStore({
    selectId: (p: BranchLocationBase) => p.branchId ?? '',
    loadAll: () => {
      return inject(BranchesApi)
        .getLocations()
        .pipe(
          map((data) => {
            return data;
          }),
        );
    },
    cacheSeconds: 60,
  }),
);
